import React from 'react';

import { Container, Left, Right, Title, Subtitle, CloseButton, CloseIcon } from './styles';

interface Props {
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  onClose?: () => void;
}

const ModalHeaderSubtitle = ({ title, subtitle, onClose }: Props) => (
  <Container>
    <Left>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Left>
    {onClose && (
      <Right>
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </Right>
    )}
  </Container>
);

export default ModalHeaderSubtitle;
